/**
 * redux middleware that handle "fetch" key in redux action.
 * {
 *  ...,
 *  fetch: (service) => service.fetch(url, method, body, header, fields),
 * }
 */

import has from 'lodash/has';

export default function fetcherMiddleware(defService = {}) {
  return store => next => action => {
    if (!action.fetch) {
      return next(action);
    }
    const { fetch, type, types, ...rest } = action;

    const service = instantiateService(defService, store); // create every instance of service
    const response = !!fetch && fetch(service);

    let INITIAL_TYPE = type,
      SUCCESS_TYPE = type;
    let ERROR_TYPE = null;
    if (has(action, 'types') && types.length === 3) {
      [INITIAL_TYPE, SUCCESS_TYPE, ERROR_TYPE] = types;
      next({ ...rest, type: INITIAL_TYPE }); // eslint-disable-line callback-return
    }

    return Promise.resolve(response).then(
      result => next({ ...rest, result, type: SUCCESS_TYPE }),
      error => {
        if (ERROR_TYPE) {
          return next({ ...rest, error, type: ERROR_TYPE });
        }
        throw error;
      }
    );
  };
}

export function instantiateService(defService, store) {
  let service = null;
  if (defService.constructor.name === 'Object') {
    // check if object, not an instance of any class.
    service = {};
    Object.entries(defService).forEach(([serviceName, def]) => {
      service[serviceName] = createService(def, store);
    });
  } else {
    service = createService(defService, store);
  }
  return service;
}

export function createService(def, store) {
  return typeof def === 'function' ? def(store) : def;
}
